<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p41"><span><a id="page_32"></a><a href="#/Contents#rp41">CUCUMBER AND SORREL SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>Spinach, kale, or any favorite leafy green can be substituted for the sorrel.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>¼ cup sliced green onions</span></p>
<p class="hang"><span>1 clove garlic, minced</span></p>
<p class="hang"><span>3 cups peeled, seeded, chopped cucumbers</span></p>
<p class="hang"><span>1 cup coarsely chopped sorrel</span></p>
<p class="hang"><span>2 cups each: fat-free milk, reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>1 tablespoon cornstarch</span></p>
<p class="hang"><span>2 tablespoons water</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>1½ cups Herb Croutons (½ recipe) (see <span href="#/Chapter131#p849a" title="Link target outside of Sample">p. 636</span>)</span></p>
<p class="normalt"><span><b>1.</b> Sauté onions and garlic in lightly greased large saucepan until tender, 3 to 4 minutes. Add cucumbers and sorrel, and cook over medium heat 5 minutes. Add milk and broth; heat to boiling. Reduce heat and simmer, covered, until cucumbers are tender, 5 to 10 minutes. Process soup in food processor or blender until smooth; return to saucepan and heat to boiling. Whisk in combined cornstarch and water, whisking until thickened, about 1 minute. Season to taste with salt and white pepper. Refrigerate until chilled; top each bowl of soup with Herb Croutons.</span></p>
<p class="normalt"><span>45-<span class="small">MINUTE PREPARATION TIP</span>: Make Herb Croutons and bake while preparing soup.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 70</span></p>
<p class="per1"><span>% calories from fat: 10</span></p>
<p class="per1"><span>Protein (g): 4.5</span></p>
<p class="per1"><span>Carbohydrate (g): 11.7</span></p>
<p class="per1"><span>Fat (g): 0.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 1.3</span></p>
<p class="per1"><span>Sodium (mg): 94</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.5</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0223.vue?d4de7798